import { c as _c } from "react/compiler-runtime";
import { randomBytes } from "crypto";
import { useCallback, useMemo } from "react";
import useSWR from "swr";
import type { SequenceState, UseFf } from "../types";
type AnyJson = Record<string, unknown>;
export const makeSwrFf = <T extends AnyJson, U extends AnyJson>(f: (arg: T) => Promise<U>): UseFf<T, U> => {
  // Cache key is required for swr but not for the fetcher function
  const ck = randomBytes(20).toString("hex");
  const fWithCacheKey = ([arg, _ck]: [T, string]) => f(arg);
  const useFfWithSwr: UseFf<T, U> = arg => {
    const $ = _c(13);
    let t0;
    if ($[0] !== arg) {
      t0 = [arg, ck];
      $[0] = arg;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    const {
      data,
      error,
      mutate
    } = useSWR(t0, fWithCacheKey);
    let t1;
    if ($[2] !== data || $[3] !== mutate) {
      t1 = () => {
        mutate(data);
      };
      $[2] = data;
      $[3] = mutate;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    const refetch = t1;
    let t2;
    bb0: {
      if (data != null) {
        let t3;
        if ($[5] !== data) {
          t3 = {
            status: "ok",
            data
          };
          $[5] = data;
          $[6] = t3;
        } else {
          t3 = $[6];
        }
        t2 = t3;
        break bb0;
      }
      if (error != null) {
        let t3;
        if ($[7] !== error) {
          t3 = {
            status: "ng",
            error
          };
          $[7] = error;
          $[8] = t3;
        } else {
          t3 = $[8];
        }
        t2 = t3;
        break bb0;
      }
      let t3;
      if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
          status: "loading"
        };
        $[9] = t3;
      } else {
        t3 = $[9];
      }
      t2 = t3;
    }
    const seqState = t2;
    let t3;
    if ($[10] !== refetch || $[11] !== seqState) {
      t3 = [seqState, refetch];
      $[10] = refetch;
      $[11] = seqState;
      $[12] = t3;
    } else {
      t3 = $[12];
    }
    return t3;
  };
  return useFfWithSwr;
};